var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeCheckOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9999 7.99999L7.33323 9.33333L9.9999 6.66666M5.22323 3.13133C5.70144 3.09316 6.15542 2.90513 6.52057 2.59399C6.93317 2.24217 7.45766 2.04892 7.9999 2.04892C8.54214 2.04892 9.06663 2.24217 9.47923 2.59399C9.84438 2.90513 10.2984 3.09316 10.7766 3.13133C11.3171 3.17433 11.8246 3.40854 12.208 3.79194C12.5914 4.17534 12.8256 4.68283 12.8686 5.22333C12.9067 5.70153 13.0948 6.15551 13.4059 6.52066C13.7577 6.93327 13.951 7.45775 13.951 7.99999C13.951 8.54223 13.7577 9.06672 13.4059 9.47933C13.0948 9.84447 12.9067 10.2985 12.8686 10.7767C12.8256 11.3172 12.5914 11.8246 12.208 12.208C11.8246 12.5914 11.3171 12.8257 10.7766 12.8687C10.2984 12.9068 9.84438 13.0949 9.47923 13.406C9.06663 13.7578 8.54214 13.9511 7.9999 13.9511C7.45766 13.9511 6.93317 13.7578 6.52057 13.406C6.15542 13.0949 5.70144 12.9068 5.22323 12.8687C4.68273 12.8257 4.17525 12.5914 3.79185 12.208C3.40845 11.8246 3.17423 11.3172 3.13123 10.7767C3.09307 10.2985 2.90503 9.84447 2.5939 9.47933C2.24208 9.06672 2.04883 8.54223 2.04883 7.99999C2.04883 7.45775 2.24208 6.93327 2.5939 6.52066C2.90503 6.15551 3.09307 5.70153 3.13123 5.22333C3.17423 4.68283 3.40845 4.17534 3.79185 3.79194C4.17525 3.40854 4.68273 3.17433 5.22323 3.13133Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeCheckOutline);
export default __webpack_public_path__ + "static/media/BadgeCheckOutline.18c355906ce9d8ef39142c3abf4df340.svg";
export { ForwardRef as ReactComponent };